// extracted by css-extract-rspack-plugin
var _1 = "IvKSdtaPLRoLQ5KK";
var _2 = "dBNJnB4TImMhVJI7";
var _3 = "ya5wX4OFs9YOo4uq";
var _4 = "bQHujNXdmJklsjhL";
var _5 = "uoy00U2cC98LCdLT";
export { _1 as "checkboxCheckedMark", _2 as "checkboxCheckedMarkSvg", _3 as "checkboxFrame", _4 as "checkboxFrameSvg", _5 as "checkboxWrapStyle" }
